import { Container } from "@mui/material";
import { FormManage } from "./form-manage";

export function FormPageManage() {

    return (
        <Container>

            <FormManage />

        </Container>
    );

}
